import React from 'react'
import PropTypes from 'prop-types'

const ExceptionContainer = props => {
  let inner
  if (props.ruleExists) {
    inner = (
      <div>
        {props.children}
        <button
          onClick={() => props.updateExists(false)}
          className="btn btn-sm btn-danger float-right mt-1"
        >
          <span className="fa-regular fa-trash-alt fa-fw" /> Delete{' '}
        </button>
      </div>
    )
  } else {
    inner = (
      <div className="d-flex flex-column align-items-center">
        <div className="text-center my-1"> Add an Exception </div>
        <button
          onClick={() => props.updateExists(true)}
          className="btn btn-sm btn-dark-blue"
        >
          <span className=" fa-regular fa-plus-circle fa-fw" /> Add{' '}
        </button>
      </div>
    )
  }

  return (
    <div className="card w-100 maxw-600px m-2">
      <div className="card-body">
        <h5 className="card-title border-bottom">
          {' '}
          <span className={`fa-solid fa-${props.icon} fa-fw`} /> {props.title}
          <span
            className={`fa-solid fa-${
              props.saved
                ? 'check text-success'
                : 'exclamation-triangle text-warning'
            } float-right`}
          />
        </h5>
        <div>
          <div
            className={`alert-danger rounded p-1 m-3 ${
              props.errorMessage ? '' : 'd-none'
            }`}
          >
            {' '}
            {props.errorMessage}{' '}
          </div>
          <div
            className={`float-sm-right fs-sm mb-1 ${
              props.saved ? 'd-none' : ''
            }`}
          >
            (Unsaved Changes)
          </div>
        </div>
        {inner}
      </div>
    </div>
  )
}

ExceptionContainer.propTypes = {
  title: PropTypes.string,
  ruleExists: PropTypes.bool,
  updateExists: PropTypes.func,
  icon: PropTypes.string,
  saved: PropTypes.bool,
  errorMessage: PropTypes.string,
}

export default ExceptionContainer
